import React from 'react'
import { useHistory } from 'react-router-dom'
import { useGapFillerQueryParams, useRecallQueryParams } from '@hooks/useQueryParams'
import { AppMode } from '@customTypes/Generic'
import routes from 'src/config/routes'
import { seenAppointment } from 'src/services/analytics'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import useWizardManager from '@hooks/useWizardManager'
import AppointmentScreen from '@screens/Appointment'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { useVerifyPhoneContext } from '@context/VerifyPhoneContext'

const Appointment = () => {
  const history = useHistory()
  const { mode } = useConfig()
  const { patientType } = useChoiceState()
  const recall = useRecallQueryParams()
  const gapFiller = useGapFillerQueryParams()
  const { linkedPatients } = useVerifyPhoneContext()

  const isNewPatient = patientType === PatientTypeOptions.NEW

  const isInRecallMode = mode === AppMode.RECALL
  const isInGapFillerMode = mode === AppMode.GAP_FILLER

  useWizardManager({
    targetRoute: routes.appointment,
    onValidStep: () => seenAppointment(),
    skip: isInRecallMode || isInGapFillerMode,
  })

  const handleBackClicked = () => {
    if (isNewPatient) {
      history.push(routes.patient)
    } else {
      if (linkedPatients.length > 1) {
        history.push(routes.oldPatientSelectAccount)
      } else {
        history.push(routes.patient)
      }
    }
  }

  if (isInRecallMode && !recall.hasAllRequiredParams) {
    return null
  }

  if (isInGapFillerMode && !gapFiller.hasAllRequiredParams) {
    return null
  }

  if (!isInRecallMode && !isInGapFillerMode && !patientType) {
    return null
  }

  return <AppointmentScreen onBackClicked={isInGapFillerMode || isInRecallMode ? undefined : handleBackClicked} />
}

export default Appointment
